import { PatternFormat, type PatternFormatProps } from 'react-number-format';

/**
 * Input de CPF com máscara de CPF (###.###.###-##). O CPF permanece
 * exclusivamente numérico — a IN RFB 2.229/2024 tornou alfanumérico apenas o
 * CNPJ — então o PatternFormat atende; este wrapper é o par do CnpjInput,
 * para que campos de documento tenham um único ponto de definição.
 *
 * Em onValueChange: `values.value` são os dígitos sem máscara e
 * `values.formattedValue` é o CPF mascarado.
 */
export type CpfInputProps = Omit<PatternFormatProps, 'format' | 'patternChar'>;

export const CpfInput = (props: CpfInputProps) => <PatternFormat {...props} format="###.###.###-##" />;
